<template>
  <div
    class="autocomplete width-100"
    :data-content="$t('generalMessages.enter')"
    :class="continerClass"
  >
    <input
      :disabled="disableComponent"
      :class="inputClass"
      :placeholder="placeholder"
      type="text"
      @input="!onEnterSearch && onChange()"
      v-model="search"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
      @focus="onFocusInput"
      ref="dropdowninput"
    />
    <ul
      id="autocomplete-results"
      ref="results"
      v-show="isOpen"
      class="autocomplete-results"
      :class="dropdownClass"
      :style="dropdownStyle"
    >
      <li class="loading" v-if="isLoading">
        {{ $t("generalMessages.loadingResult") }}
      </li>
      <template v-else v-for="(result, i) in results">
        <li
          v-if="result.groupLabel && result.groupLabel !== groupLabelAt(i - 1)"
          :key="`group-${i}`"
          class="autocomplete-group"
        >
          {{ result.groupLabel }}
        </li>
        <li
          :key="i"
          @click="setResult(result)"
          class="autocomplete-result"
          :class="{ 'is-active': i === arrowCounter }"
        >
          {{ result.text }}
        </li>
      </template>
      <div v-if="hasLoadMore" class="load-more" @click="loadMore">
        {{ $t("generalMessages.loadMore") }}
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DropdownAutoComplete',

  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    onEnterSearch: {
      type: Boolean,
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectedValue: {
      required: false,
      type: [String, Number],
    },
    initialText: {
      required: false,
      type: String,
    },
    inputClass: {
      required: false,
    },
    continerClass: {
      required: false,
      type: String,
    },
    dropdownClass: {
      required: false,
      type: String,
    },
    placeholder: {
      required: false,
      type: String,
    },
    disableComponent: {
      required: false,
      type: Boolean,
    },
    onFocusDisplayList: {
      required: false,
      type: Boolean,
    },
    serverFilter: {
      required: false,
      type: Boolean,
    },
    minSearchLength: {
      required: false,
      type: Number,
      default: 3,
    },
    clearText: {
      required: false,
      type: Boolean,
    },
    clearTextOnDemand: {
      required: false,
      type: Boolean,
    },
    hasLoadMore: {
      required: false,
      type: Boolean,
      default: false,
    },
    portalToBody: {
      type: Boolean,
      default: false,
    },
  },

  model: {
    prop: 'selectedValue',
    event: 'change',
  },
  data() {
    return {
      isOpen: false,
      results: [],
      search: '',
      selectedItemValue: undefined,
      isLoading: false,
      arrowCounter: 0,
      enterKeyPressed: false,
      continerClassFromData: {},
      dropdownStyle: undefined,
    };
  },
  created() {
    if (this.initialText) {
      this.search = this.initialText;
    }
    if (typeof this.continerClass === 'string') {
      this.continerClassFromData = { ...this.continerClassFromData, [this.continerClass]: true };
    } else {
      this.continerClassFromData = { ...this.continerClassFromData, ...this.continerClass };
    }
    // if must press enter to search -> MOVED TO WATCH
    // if (this.onEnterSearch) {
    //   this.continerClassFromData = { ...this.continerClassFromData, 'input-onfocus-enter-container': true };
    // }
  },
  methods: {
    onChange() {
      // Let's warn the parent that a change was made
      if (!this.serverFilter) {
        this.$emit('input', this.search);

        // Is the data given by an outside ajax request?
        if (this.isAsync) {
          this.isLoading = true;
          this.isOpen = true;
        } else {
          // Let's  our flat array
          this.filterResults();
          this.isOpen = true;
          if (this.results && this.results.length > 0) {
            this.arrowCounter = 0;
          }
        }
      } else if (this.search.length >= this.minSearchLength || this.search.length === 0) {
        new Promise((r) => setTimeout(r, 2000));
        this.$emit('search', this.search);
      }
    },

    // A header only, never selectable: it repeats the group of the item under it.
    groupLabelAt(index) {
      return index >= 0 && this.results[index] ? this.results[index].groupLabel : undefined;
    },
    filterResults() {
      const needle = this.search.toLowerCase();
      this.results = this.items.filter(
        (item) => item.text.toLowerCase().indexOf(needle) > -1
          || (item.groupLabel || '').toLowerCase().indexOf(needle) > -1,
      );
    },
    setResult(result) {
      this.search = result.text;
      this.selectedItemValue = result.value; // this will be used on change the search input to decide to clear the list or not because it made issues
      // this.selectedValue = result;
      this.$emit('change', result.value);
      this.isOpen = false;
      this.arrowCounter = -1;
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter += 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
      }
    },
    onEnter() {
      if (this.onEnterSearch && !this.enterKeyPressed) {
        this.enterKeyPressed = true;
        this.onChange();
      }
      if (this.results.length) {
        const item = this.results[this.arrowCounter];
        if (item) {
          this.setResult(item);
        }
      }
      // this.search = item ? item.text : '';
      // this.isOpen = false;
      // this.arrowCounter = -1;
    },
    handleClickOutside(evt) {
      const results = this.$refs.results;
      if (!this.$el.contains(evt.target) && (!results || !results.contains(evt.target))) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    },
    updatePortalPosition() {
      if (!this.portalToBody || !this.$refs.dropdowninput) return;

      const inputRect = this.$refs.dropdowninput.getBoundingClientRect();
      const viewportHeight = document.documentElement.clientHeight;
      const gap = 4;
      const preferredHeight = 250;
      const spaceBelow = viewportHeight - inputRect.bottom;
      const spaceAbove = inputRect.top;
      const opensAbove = spaceBelow < preferredHeight && spaceAbove > spaceBelow;
      const availableHeight = (opensAbove ? spaceAbove : spaceBelow) - gap;

      this.dropdownStyle = {
        position: 'fixed',
        left: `${inputRect.left}px`,
        width: `${inputRect.width}px`,
        minWidth: `${inputRect.width}px`,
        maxHeight: `${Math.max(80, Math.min(preferredHeight, availableHeight))}px`,
        top: opensAbove ? 'auto' : `${inputRect.bottom + gap}px`,
        bottom: opensAbove ? `${viewportHeight - inputRect.top + gap}px` : 'auto',
        direction: window.getComputedStyle(this.$refs.dropdowninput).direction,
        zIndex: 2000,
      };
    },
    onFocusInput() {
      if (this.onFocusDisplayList) {
        this.isOpen = true;

        if (this.items.length <= 0) {
          this.$emit('load');
        }
      }
      if (this.clearText) {
        this.search = '';
      }

      // Only the items watcher fills results, so a list that was ready before this mounted left the
      // box empty until the first keystroke. An empty box offers everything -- which also means
      // reopening after a pick shows the whole list again, not the last search's leftovers.
      if (!this.search) {
        this.results = this.items;
      }
    },
    focusOnInput() {
      this.$refs.dropdowninput.focus();
    },
    loadMore() {
      this.$emit('loadMore');
    },
  },
  watch: {
    clearTextOnDemand: {
      immediate: true,
      async handler() {
        if (this.clearTextOnDemand) {
          this.search = '';
          this.initialText = '';
          this.selectedValue = undefined;
        }
      },
    },
    items: {
      deep: true,
      handler(val) {
        // actually compare them
        this.results = val;
        this.isLoading = false;
        if (this.isOpen) this.$nextTick(this.updatePortalPosition);
      },
    },
    isOpen(isOpen) {
      if (isOpen) this.$nextTick(this.updatePortalPosition);
    },
    search(val) {
      // when the enter is pressed and after that the search input value is changed then clear the list
      if (this.enterKeyPressed && this.onEnterSearch) {
        // get the selecte item if it is selected before this will be used for checking if we need to clear the value or not
        // because the default behavior of this component is when selecting an item it will change the value of the search attribute to the selected one even if it is not fully typed like if you search for test and there is only one record with the name test 222 then the value of search it will be = test 222 by the component it self which lead to fire this method
        let selectedItemText;
        const selectedObject = this.results.find((i) => i.value === this.selectedItemValue);
        if (selectedObject) {
          selectedItemText = selectedObject.text;
        }
        // so this method will clear the data if the enter key pressed before and when the text of the search is not the same one that already selected
        if (val !== selectedItemText) {
          // clear the array
          this.results = [];
          // let the parent component that there is a change and clear the result of the callback
          this.$emit('change', undefined);
          // reset the enter key flag to false as now it is not pressed for this new value
          this.enterKeyPressed = false;
        }
      }
      if (!val) {
        this.$emit('change', undefined);
        this.isLoading = false;
        this.isOpen = false;
      }
    },
    onEnterSearch: {
      immediate: true,
      handler() {
        if (this.onEnterSearch) {
          this.continerClassFromData = {
            'input-onfocus-enter-container': true,
            ...this.continerClassFromData,
          };
        } else {
          delete this.continerClassFromData['input-onfocus-enter-container'];
        }
      },
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    if (this.portalToBody && this.$refs.results) {
      document.body.appendChild(this.$refs.results);
      window.addEventListener('resize', this.updatePortalPosition);
      window.addEventListener('scroll', this.updatePortalPosition, true);
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('resize', this.updatePortalPosition);
    window.removeEventListener('scroll', this.updatePortalPosition, true);

    if (this.portalToBody && this.$refs.results && this.$el) {
      this.$el.appendChild(this.$refs.results);
    }
  },
};
</script>

<style scoped>
.autocomplete {
  position: relative;
}

.autocomplete-results {
  position: absolute;
  background-color: white;
  padding: 0;
  margin: 0;
  border: 1px solid #e1e5eb;
  border-radius: 4px;
  max-height: 250px;
  overflow: auto;
  min-width: 100%;
  white-space: nowrap;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 8px 12px;
  cursor: pointer;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: var(--fitnet-primary);
  color: white;
}

/* A heading, not a choice -- it must not look clickable or hover like a result. */
.autocomplete-group {
  list-style: none;
  padding: 6px 12px 2px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--fitnet-muted-text-color, #868e96);
  cursor: default;
  pointer-events: none;
}

.autocomplete-group + .autocomplete-result {
  padding-top: 6px;
}

.load-more {
  text-align: center;
  color:#0098b8;
  cursor: pointer;
}
</style>
